import { ApiClient, ServiceBase } from './api'

export class QZPrintService extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/common/qz-print')
  }

  // 获取托盘标签数据
  async getSign(toSign: string): Promise<string> {
    return this.get<string>(`/sign`, {
      params: { request: toSign },
      headers: {
        'Content-Type': 'text/plain'
      }
    })
  }
}
